function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module widget/widgettoolbarrepository
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ContextualBalloon from '@ckeditor/ckeditor5-ui/src/panel/balloon/contextualballoon';
import ToolbarView from '@ckeditor/ckeditor5-ui/src/toolbar/toolbarview';
import BalloonPanelView from '@ckeditor/ckeditor5-ui/src/panel/balloon/balloonpanelview';
import { isWidget, centeredBalloonPositionForLongWidgets } from './utils';
import CKEditorError, { logWarning } from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * Widget toolbar repository plugin. A central point for registering widget toolbars. This plugin handles the whole
 * toolbar rendering process and exposes a concise API.
 *
 * To add a toolbar for your widget use the {@link ~WidgetToolbarRepository#register `WidgetToolbarRepository#register()`} method.
 *
 * The following example comes from the {@link module:image/imagetoolbar~ImageToolbar} plugin:
 *
 * 		class ImageToolbar extends Plugin {
 *			static get requires() {
 *				return [ WidgetToolbarRepository ];
 *			}
 *
 *			afterInit() {
 *				const editor = this.editor;
 *				const widgetToolbarRepository = editor.plugins.get( WidgetToolbarRepository );
 *
 *				widgetToolbarRepository.register( 'image', {
 *					items: editor.config.get( 'image.toolbar' ),
 *					getRelatedElement: getClosestSelectedImageWidget
 *				} );
 *			}
 *		}
 */

var WidgetToolbarRepository = /*#__PURE__*/function (_Plugin) {
  _inherits(WidgetToolbarRepository, _Plugin);

  var _super = _createSuper(WidgetToolbarRepository);

  function WidgetToolbarRepository() {
    _classCallCheck(this, WidgetToolbarRepository);

    return _super.apply(this, arguments);
  }

  _createClass(WidgetToolbarRepository, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor; // Disables the default balloon toolbar for all widgets.

      if (editor.plugins.has('BalloonToolbar')) {
        var balloonToolbar = editor.plugins.get('BalloonToolbar');
        this.listenTo(balloonToolbar, 'show', function (evt) {
          if (isWidgetSelected(editor.editing.view.document.selection)) {
            evt.stop();
          }
        }, {
          priority: 'high'
        });
      }
      /**
       * A map of toolbar definitions.
       *
       * @protected
       * @member {Map.<String,module:widget/widgettoolbarrepository~WidgetRepositoryToolbarDefinition>} #_toolbarDefinitions
       */


      this._toolbarDefinitions = new Map();
      /**
       * @private
       */

      this._balloon = this.editor.plugins.get('ContextualBalloon');
      this.on('change:isEnabled', function () {
        _this._updateToolbarsVisibility();
      });
      this.listenTo(editor.ui, 'update', function () {
        _this._updateToolbarsVisibility();
      }); // UI#update is not fired after focus is back in editor, we need to check if balloon panel should be visible.

      this.listenTo(editor.ui.focusTracker, 'change:isFocused', function () {
        _this._updateToolbarsVisibility();
      }, {
        priority: 'low'
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(WidgetToolbarRepository.prototype), "destroy", this).call(this);

      var _iterator = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var toolbarConfig = _step.value;
          toolbarConfig.view.destroy();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Registers toolbar in the WidgetToolbarRepository. It renders it in the `ContextualBalloon` based on the value of the invoked
     * `getRelatedElement` function. Toolbar items are gathered from `items` array.
     * The balloon's CSS class is by default `ck-toolbar-container` and may be override with the `balloonClassName` option.
     *
     * Note: This method should be called in the {@link module:core/plugin~PluginInterface#afterInit `Plugin#afterInit()`}
     * callback (or later) to make sure that the given toolbar items were already registered by other plugins.
     *
     * @param {String} toolbarId An id for the toolbar. Used to
     * @param {Object} options
     * @param {String} [options.ariaLabel] Label used by assistive technologies to describe this toolbar element.
     * @param {Array.<String>} options.items Array of toolbar items.
     * @param {Function} options.getRelatedElement Callback which returns an element the toolbar should be attached to.
     * @param {String} [options.balloonClassName='ck-toolbar-container'] CSS class for the widget balloon.
     */

  }, {
    key: "register",
    value: function register(toolbarId, _ref) {
      var ariaLabel = _ref.ariaLabel,
          items = _ref.items,
          getRelatedElement = _ref.getRelatedElement,
          _ref$balloonClassName = _ref.balloonClassName,
          balloonClassName = _ref$balloonClassName === void 0 ? 'ck-toolbar-container' : _ref$balloonClassName;

      // Trying to register a toolbar without any item.
      if (!items.length) {
        /**
         * When {@link #register} a new toolbar, you need to provide a non-empty array with
         * the items that will be inserted into the toolbar.
         *
         * @error widget-toolbar-no-items
         */
        logWarning('widget-toolbar-no-items', {
          toolbarId: toolbarId
        });
        return;
      }

      var editor = this.editor;
      var t = editor.t;
      var toolbarView = new ToolbarView(editor.locale);
      toolbarView.ariaLabel = ariaLabel || t('Widget toolbar');

      if (this._toolbarDefinitions.has(toolbarId)) {
        /**
         * Toolbar with the given id was already added.
         *
         * @error widget-toolbar-duplicated
         * @param toolbarId Toolbar id.
         */
        throw new CKEditorError('widget-toolbar-duplicated', this, {
          toolbarId: toolbarId
        });
      }

      toolbarView.fillFromConfig(items, editor.ui.componentFactory);

      this._toolbarDefinitions.set(toolbarId, {
        view: toolbarView,
        getRelatedElement: getRelatedElement,
        balloonClassName: balloonClassName
      });
    }
    /**
     * Iterates over stored toolbars and makes them visible or hidden.
     *
     * @private
     */

  }, {
    key: "_updateToolbarsVisibility",
    value: function _updateToolbarsVisibility() {
      var maxRelatedElementDepth = 0;
      var deepestRelatedElement = null;
      var deepestToolbarDefinition = null;

      var _iterator2 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var definition = _step2.value;
          var relatedElement = definition.getRelatedElement(this.editor.editing.view.document.selection);

          if (!this.isEnabled || !relatedElement) {
            if (this._isToolbarInBalloon(definition)) {
              this._hideToolbar(definition);
            }
          } else if (!this.editor.ui.focusTracker.isFocused) {
            if (this._isToolbarVisible(definition)) {
              this._hideToolbar(definition);
            }
          } else {
            var relatedElementDepth = relatedElement.getAncestors().length; // Many toolbars can express willingness to be displayed but they do not know about
            // each other. Figure out which toolbar is deepest in the view tree to decide which
            // should be displayed. For instance, if a selected image is inside a table cell, display
            // the ImageToolbar rather than the TableToolbar (#60).

            if (relatedElementDepth > maxRelatedElementDepth) {
              maxRelatedElementDepth = relatedElementDepth;
              deepestRelatedElement = relatedElement;
              deepestToolbarDefinition = definition;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (deepestToolbarDefinition) {
        this._showToolbar(deepestToolbarDefinition, deepestRelatedElement);
      }
    }
    /**
     * Hides the given toolbar.
     *
     * @private
     * @param {module:widget/widgettoolbarrepository~WidgetRepositoryToolbarDefinition} toolbarDefinition
     */

  }, {
    key: "_hideToolbar",
    value: function _hideToolbar(toolbarDefinition) {
      this._balloon.remove(toolbarDefinition.view);

      this.stopListening(this._balloon, 'change:visibleView');
    }
    /**
     * Shows up the toolbar if the toolbar is not visible.
     * Otherwise, repositions the toolbar's balloon when toolbar's view is the most top view in balloon stack.
     *
     * It might happen here that the toolbar's view is under another view. Then do nothing as the other toolbar view
     * should be still visible after the {@link module:core/editor/editorui~EditorUI#event:update}.
     *
     * @private
     * @param {module:widget/widgettoolbarrepository~WidgetRepositoryToolbarDefinition} toolbarDefinition
     * @param {module:engine/view/element~Element} relatedElement
     */

  }, {
    key: "_showToolbar",
    value: function _showToolbar(toolbarDefinition, relatedElement) {
      var _this2 = this;

      if (this._isToolbarVisible(toolbarDefinition)) {
        repositionContextualBalloon(this.editor, relatedElement);
      } else if (!this._isToolbarInBalloon(toolbarDefinition)) {
        this._balloon.add({
          view: toolbarDefinition.view,
          position: getBalloonPositionData(this.editor, relatedElement),
          balloonClassName: toolbarDefinition.balloonClassName
        }); // Update toolbar position each time stack with toolbar view is switched to visible.
        // This is in a case target element has changed when toolbar was in invisible stack
        // e.g. target image was wrapped by a block quote.
        // See https://github.com/ckeditor/ckeditor5-widget/issues/92.


        this.listenTo(this._balloon, 'change:visibleView', function () {
          var _iterator3 = _createForOfIteratorHelper(_this2._toolbarDefinitions.values()),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var definition = _step3.value;

              if (_this2._isToolbarVisible(definition)) {
                var _relatedElement = definition.getRelatedElement(_this2.editor.editing.view.document.selection);

                repositionContextualBalloon(_this2.editor, _relatedElement);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        });
      }
    }
    /**
     * @private
     * @param {Object} toolbar
     * @returns {Boolean}
     */

  }, {
    key: "_isToolbarVisible",
    value: function _isToolbarVisible(toolbar) {
      return this._balloon.visibleView === toolbar.view;
    }
    /**
     * @private
     * @param {Object} toolbar
     * @returns {Boolean}
     */

  }, {
    key: "_isToolbarInBalloon",
    value: function _isToolbarInBalloon(toolbar) {
      return this._balloon.hasView(toolbar.view);
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ContextualBalloon];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'WidgetToolbarRepository';
    }
  }]);

  return WidgetToolbarRepository;
}(Plugin);

export { WidgetToolbarRepository as default };

function repositionContextualBalloon(editor, relatedElement) {
  var balloon = editor.plugins.get('ContextualBalloon');
  var position = getBalloonPositionData(editor, relatedElement);
  balloon.updatePosition(position);
}

function getBalloonPositionData(editor, relatedElement) {
  var editingView = editor.editing.view;
  var defaultPositions = BalloonPanelView.defaultPositions;
  return {
    target: editingView.domConverter.mapViewToDom(relatedElement),
    positions: [defaultPositions.northArrowSouth, defaultPositions.northArrowSouthWest, defaultPositions.northArrowSouthEast, defaultPositions.southArrowNorth, defaultPositions.southArrowNorthWest, defaultPositions.southArrowNorthEast, centeredBalloonPositionForLongWidgets]
  };
}

function isWidgetSelected(selection) {
  var viewElement = selection.getSelectedElement();
  return !!(viewElement && isWidget(viewElement));
}
/**
 * The toolbar definition object used by the toolbar repository to manage toolbars.
 * It contains information necessary to display the toolbar in the
 * {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon} and
 * update it during its life (display) cycle.
 *
 * @typedef {Object} module:widget/widgettoolbarrepository~WidgetRepositoryToolbarDefinition
 *
 * @property {module:ui/view~View} view The UI view of the toolbar.
 * @property {Function} getRelatedElement A function that returns an engine {@link module:engine/view/view~View}
 * element the toolbar is to be attached to. For instance, an image widget or a table widget (or `null` when
 * there is no such element). The function accepts an instance of {@link module:engine/view/selection~Selection}.
 * @property {String} balloonClassName CSS class for the widget balloon when a toolbar is displayed.
 */